
import { Dispatch, SetStateAction } from 'react';
import { KaziModal } from '../../../Shared Components/Kazi/KaziModal';
import { Typography } from '@mui/material';
import { KaziButton } from '../../../Shared Components/Kazi/KaziButton';

interface VerificationConsentModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    handleBack: () => void;
    handleVerify: () => void;
}

export const VerificationConsentModal = ({open, setOpen, handleBack, handleVerify}:VerificationConsentModalProps ) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false)
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal
            open={open}
            handleClose={handleClose}
            title='Consent to OTP'
            content={
                <Typography >
                    By entering your phone number and clicking "Yes, send me the code” 
                    you are requesting that we send a One-Time Password (OTP) 
                    to your provided number for authentication purposes. 
                    By proceeding, you consent to receive this message.
                </Typography>
            }
            actions={[
                <KaziButton 
                    text="No, don't send"
                    variant='outlined'
                    onClick={handleBack}
                />,
                <KaziButton 
                    text="Yes, send me the code"
                    variant='contained'
                    color='primary'
                    onClick={handleVerify}
                />
            ]}
        />
    )
}